var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import _ from 'lodash';
import React from 'react';
import { Modal, Row, Col, Input, Select, InputNumber, Checkbox, Radio, Button, Form } from 'antd';
import './index.less';
const formFieldTypes = ['input', 'number', 'checkbox', 'radio', 'select'];
export default class ConfigUI extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            objOptions: {},
            isLoading: false,
            loading: {},
            values: this.mapFieldsValue(props.config.fields)
        };
    }
    componentWillReceiveProps(nextProps) {
        const { values } = this.state;
        const nextValues = this.mapFieldsValue(nextProps.config.fields);
        if (!_.isEqual(values, nextValues)) {
            this.setState({
                values: nextValues
            });
        }
    }
    mapFieldsValue(fields) {
        const values = {};
        fields.forEach((field) => {
            if (!_.isEmpty(field.type)) {
                values[field.id] = field.value;
            }
        });
        return values;
    }
    fieldText(label) {
        const { formatMessage } = this.props;
        if (label && !_.isEmpty(label)) {
            let tag = 'p';
            let text = '';
            let style = {};
            if (_.isString(label)) {
                text = label;
            }
            else if (_.isObject(label)) {
                tag = label.tag || 'p';
                text = label.text;
                style = label.style || {};
            }
            text = formatMessage({ id: text, defaultMessage: text });
            return React.createElement(tag, { style }, text);
        }
        return null;
    }
    fieldContent(data) {
        const { type, value, props = {}, onChange } = data;
        const { formatMessage } = this.props;
        const { values } = this.state;
        if (!_.isUndefined(type) && !_.isUndefined(value) && !_.isEmpty(type)) {
            switch (type.toLowerCase()) {
                case 'image':
                    return (React.createElement("p", null,
                        React.createElement("img", { style: { maxWidth: '100%', display: 'block' }, alt: "is a picture", src: value })));
                case 'text':
                    return (React.createElement("p", null, formatMessage({ id: value.toString(), defaultMessage: value.toString() })));
                case 'input':
                    return (React.createElement(Input, Object.assign({}, props, { style: { width: '100%' }, defaultValue: values[data.id] || data.value, onChange: (e) => this.fieldValue(data.id, e.target.value, onChange) })));
                case 'number':
                    return (React.createElement(InputNumber, { style: { width: '100%' } }));
                case 'checkbox':
                    return (React.createElement(Checkbox, null));
                case 'radio':
                    return (React.createElement(Radio, null));
                case 'select':
                    return this.selectField(data);
                default:
                    break;
            }
        }
        return null;
    }
    transProps(props = {}, id) {
        const { objOptions = {}, values } = this.state;
        const { onBlur = () => { }, onSearch = () => { }, onSelect = () => { }, onDeselect = () => { }, onFocus = () => { }, onPopupScroll = () => { }, onInputKeyDown = () => { }, onMouseEnter = () => { }, onMouseLeave = () => { }, onChange = () => { } } = props, other = __rest(props, ["onBlur", "onSearch", "onSelect", "onDeselect", "onFocus", "onPopupScroll", "onInputKeyDown", "onMouseEnter", "onMouseLeave", "onChange"]);
        const resetOptions = (option) => {
            if (option instanceof Array && option.length > 0) {
                objOptions[id] = option;
                this.setState({ objOptions });
            }
        };
        const resetValues = (value) => {
            values[id] = value;
            this.setState({ values });
        };
        return Object.assign({ onBlur: () => {
                onBlur();
            }, onFocus: () => {
                onFocus();
            }, onSearch: (value) => {
                onSearch(value, resetOptions);
            }, onSelect: (value) => {
                onSelect(value, resetValues);
            }, onDeselect: (args) => {
                onDeselect(...args);
            }, onPopupScroll: () => {
                onPopupScroll();
            }, onInputKeyDown: (args) => {
                onInputKeyDown(...args);
            }, onMouseEnter: (args) => {
                onMouseEnter(...args);
            }, onMouseLeave: (args) => {
                onMouseLeave(...args);
            }, onChange: (value) => {
                resetValues(value);
            } }, other);
    }
    selectField(data) {
        const { values, objOptions: options } = this.state;
        const { props, id } = data;
        return (React.createElement(Select, Object.assign({ style: { width: '100%' }, value: values[data.id] || data.value }, this.transProps(props, id)), this.fieldSelectOptions(options[id] || data.options)));
    }
    fieldSelectOptions(options) {
        const { formatMessage } = this.props;
        const elements = [];
        const push = (options) => {
            try {
                for (let index = 0; index < options.length; index++) {
                    const option = options[index];
                    let text = _.isString(option) ? option : option.text;
                    let value = _.isString(option) ? option : option.value.toString();
                    elements.push(React.createElement(Select.Option, { key: index, value: value }, formatMessage({ id: text, defaultMessage: text })));
                }
            }
            catch (error) {
                console.warn(error);
            }
        };
        if (_.isFunction(options)) {
            const p = options();
            if (p instanceof Promise) {
                // TODO SYNC LOAD OPTIONS
                p.then((res) => {
                    push(res);
                });
            }
            else {
                push(p);
            }
        }
        else if (_.isArray(options)) {
            push(options);
        }
        return elements;
    }
    fieldValue(id, val, onChange) {
        const { values } = this.state;
        values[id] = val;
        this.setState({ values });
        _.isFunction(onChange) && onChange(val);
        return val;
    }
    field(data, index) {
        const { layout = {
            span: 24,
            style: {}
        } } = data;
        const { span, style } = layout;
        const props = {
            id: data.id || `cfgUIField${index}`,
            key: index,
            span,
            style,
        };
        const isFormField = data.type && formFieldTypes.indexOf(data.type) !== -1;
        if (isFormField) {
            const { formatMessage } = this.props;
            const label = (data.label || '');
            return (React.createElement(Col, Object.assign({}, props),
                React.createElement(Form.Item, { label: formatMessage({ id: label, defaultMessage: label }), extra: data.info }, this.fieldContent(data))));
        }
        else {
            return (React.createElement(Col, Object.assign({}, props),
                this.fieldText(data.label),
                this.fieldContent(data),
                this.fieldText(data.info)));
        }
    }
    content(fields) {
        try {
            if (fields && !_.isEmpty(fields)) {
                return (React.createElement(Row, { type: "flex", gutter: 16 }, fields.map((field, index) => {
                    return this.field(field, index);
                })));
            }
        }
        catch (error) {
            console.warn(error);
        }
        return null;
    }
    changeLoading(id, status) {
        const { loading } = this.state;
        loading[id] = status;
        this.setState({
            isLoading: status,
            loading
        });
    }
    handleButtonClick(button) {
        const { id, handle } = button;
        const ctx = {
            values: this.state.values,
            button: this[id],
            close: this.props.onCancel || (() => { })
        };
        if (handle && _.isFunction(handle)) {
            const p = handle(ctx);
            if (p instanceof Promise) {
                this.changeLoading(id, true);
                p.then(() => {
                    this.changeLoading(id, false);
                }).catch((error) => {
                    console.warn(error);
                });
            }
        }
        else {
            ctx.close();
        }
    }
    footer(buttons) {
        if (buttons && !_.isEmpty(buttons)) {
            return (React.createElement("section", { className: "button-container" }, buttons.map((button, index) => {
                const { id, type = 'primary', style = {} } = button;
                const { loading } = this.state;
                const isLoading = loading[id];
                const props = {
                    type,
                    style,
                    key: index,
                    ref: (button) => this[id] = button,
                    loading: isLoading,
                    onClick: () => this.handleButtonClick(button)
                };
                const { formatMessage } = this.props;
                let text = button.text;
                if (isLoading) {
                    text = button.loadingText || button.text;
                }
                text = formatMessage({ id: text, defaultMessage: text });
                return (React.createElement(Button, Object.assign({}, props), text));
            })));
        }
        return null;
    }
    render() {
        const { visible, onCancel, config } = this.props;
        const { formatMessage } = this.props;
        const { isLoading } = this.state;
        if (config && !_.isEmpty(config)) {
            const { title, width = 480, maskClosable = false, closable = true, fields, buttons } = config;
            const isClosable = isLoading ? false : closable;
            let realTitle = title;
            if (title) {
                realTitle = formatMessage({ id: title, defaultMessage: title });
            }
            return (React.createElement(Modal, { title: realTitle, destroyOnClose: true, className: "custom-modal", width: width, visible: visible, keyboard: isClosable, maskClosable: maskClosable, closable: isClosable, footer: this.footer(buttons), onCancel: onCancel }, this.content(fields)));
        }
        return null;
    }
}
